import { Box, Text } from '@mantine/core';
import { ChatFile, UploadingChatFile } from '../chats/types';
import { ChatFileCardRow } from './ChatFileCardRow';

export function ChatFileList({
  files,
  uploadingFiles = [],
  onRemove,
}: {
  files: ChatFile[];
  uploadingFiles?: UploadingChatFile[];
  onRemove?: (file: ChatFile) => void;
}) {
  if (files.length === 0 && uploadingFiles.length === 0) return null;

  return (
    <Box mb="sm">
      <Text size="sm" c="gray.5" mb="xs">
        Files will be added to this chat only
      </Text>
      <ChatFileCardRow
        files={files}
        uploadingFiles={uploadingFiles}
        onRemove={onRemove ? index => onRemove(files[index]) : undefined}
      />
    </Box>
  );
}
